var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PEC_img1"},[_c('img',{attrs:{"src":this.imgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }